export enum ConditionSourceType {
	PreviousQuestion = 1,
	FileAttribute = 2,
	HrisAttribute = 3,
	HierarchyNode = 4,
}
